const research = {};

const researchEventTypes = {
  research,
};

export default researchEventTypes;
